import React from 'react';

export const CallToActionButton = ({ children, variant = 'primary', onClick, className = '' }) => {

  const baseClasses = "btn d-flex align-items-center justify-content-center gap-2 mx-auto shadow-sm rounded-pill";

  const variantClasses = variant === 'primary'
    ? "btn-primary"
    : "btn-outline-primary";

  const customStyles = {
    width: '305px',
    height: '48px',
    background: variant === 'primary' ? 'linear-gradient(135deg, #0d6efd 0%, #0b5ed7 100%)' : 'transparent',
    border: variant === 'primary' ? 'none' : '1px solid #0d6efd',
    letterSpacing: '0.5px'
  };

  return (
    <button
      className={`${baseClasses} ${variantClasses} ${className}`}
      onClick={onClick}
      style={customStyles}
    >
      {children}
    </button>
  );
};
